var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 1.067c-.589 0-1.066.477-1.066 1.066v11.734c0 .589.477 1.066 1.066 1.066h11.734c.589 0 1.066-.477 1.066-1.066V2.133c0-.589-.477-1.066-1.066-1.066H2.133zM3.253 6.4H5.28v6.4H3.253V6.4zm2.16-2.128a1.147 1.147 0 11-2.293 0 1.147 1.147 0 012.293 0zM12.8 8.914c0-1.925-1.244-2.674-2.48-2.674a2.349 2.349 0 00-1.17.246c-.273.138-.56.453-.782 1h-.057V6.4H6.4v6.405h2.033V9.399c-.03-.35.082-.8.31-1.068.23-.269.556-.333.804-.365h.077c.647 0 1.127.4 1.127 1.409v3.43h2.033l.016-3.89z"
  })));
};
export default SvgLinkedin;